import utils from 'utils';
export default class projectInfoListCtrl {
  constructor(
    $scope,
    $uibModal,
    httpRequest,
    $state,
    $stateParams,
    dictService,
    sweetalert,
    initSortService,
    $rootScope,
    logger
  ) {
    $scope.userType = $rootScope.userInfo.user.userType;
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        orgId: '',
        projectAddress: '',
        projectCode: '',
        projectName: '',
        status: '',
      },
    };
    // 表头排序
    if ($scope.userType == 0) {
      $scope.orderMap = initSortService('tenantProjectInfoListParam');
    } else {
      $scope.queryParam.param.orgId = $rootScope.userInfo.user.currentOrgId;
      $scope.orderMap = initSortService('projectInfoListParam');
    }
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      setStorageParam(JSON.stringify($scope.queryParam));
      $scope.queryOrgInfo();
    };
    $scope.goAddProjectPage = function goAddProjectPage() {
      $state.go('system.basedata.projectInfo.add', {
        orgId: $scope.queryParam.param.orgId,
      });
    };
    $scope.queryOrgInfo = function () {
      let paramTmp = { ...$scope.queryParam.param };
      paramTmp.orgId =
        $scope.queryParam.param.orgId === -2
          ? -1
          : $scope.queryParam.param.orgId;
      httpRequest
        .post_qryProjectList({
          ...$scope.queryParam,
          param: paramTmp,
        })
        .then((res) => {
          $scope.listData = res.data.value.list;
          utils.loaded();
          $scope.queryParam.pageNum = res.data.value.pageNum;
          $scope.totalItems = res.data.value.total;
          setStorageParam(JSON.stringify($scope.queryParam));
        });
    };
    $scope.searchList = function () {
      setStorageParam(JSON.stringify($scope.queryParam));
      $scope.queryOrgInfo();
    };
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      let oldParams = getStorageParam();
      let params = JSON.stringify({
        orderMap: $scope.queryParam.orderMap,
        pageNum: $scope.queryParam.pageNum,
        pageSize: $scope.queryParam.pageSize,
        param: oldParams
          ? oldParams
          : {
              orgId: $scope.queryParam.param.orgId || '',
              projectAddress: '',
              projectCode: '',
              projectName: '',
              status: '',
            },
      });
      setStorageParam(params);
      $scope.queryOrgInfo();
    };
    // 导入配置
    $scope.importconfig = {
      code:
        localStorage.deployType == 2 ? 'BUSINESS_SYS_PROJECT' : 'SYS_PROJECT',
      validate: {
        pattern: '.xlsx,.xls,.xml',
        _validate: {
          size: {
            min: 10,
            max: '10MB',
          },
          duration: {
            min: '10s',
            max: '5m',
          },
          accept: '.xlsx,.xls,.xml',
        },
      },
      callback() {
        $scope.queryOrgInfo();
      },
    };

    $scope.showSelected = function showSelected(node, flag) {
      if ($scope.userType == 0) {
        $scope.queryParam.pageNum = 1;
        $scope.queryParam.param.orgId = node.orgId;
        setStorageParam(JSON.stringify($scope.queryParam));
        // 设置选中的表
        $scope.queryOrgInfo();
      }
    };
    $scope.customizedConfig = {
      version: 1.02,
      queryConfig: [
        {
          label: '项目编号',
          selected: true,
          default: true,
        },
        {
          label: '项目名称',
          selected: true,
          default: true,
        },
        {
          label: '项目地址',
          selected: true,
          default: true,
        },
        {
          label: '启用标识',
          selected: true,
          default: true,
        },
      ],
      table: [
        {
          label: '项目编号',
          selected: true,
          default: true,
        },
        {
          label: '项目名称',
          selected: true,
          default: true,
        },
        {
          label: '项目地址',
          selected: true,
          default: true,
        },
        {
          label: '所属机构',
          selected: true,
          default: true,
        },
        {
          label: '开始时间',
          selected: true,
          default: true,
        },
        {
          label: '结束时间',
          selected: true,
          default: true,
        },
        {
          label: '负责人',
          selected: true,
          default: true,
        },
        {
          label: '联系方式',
          selected: true,
          default: true,
        },
        {
          label: '有效标识',
          selected: true,
          default: true,
        },
        {
          label: '项目描述',
          selected: true,
          default: true,
        },
      ],
    };
    $scope.queryOrgInfo();

    // 表格下拉框
    $scope.tableDropdownConfig = [
      {
        label: '编辑',
        handler(item) {
          $state.go('system.basedata.projectInfo.edit', {
            projectId: item.projectId,
          });
        },
        showWhile(item, hasPermit) {
          return hasPermit('edit_project');
        },
      },
      {
        label: '禁用',
        handler(item) {
          httpRequest
            .post_modProject({ ...item, status: 0 }, '禁用成功')
            .then(() => {
              $scope.queryOrgInfo();
            });
        },
        showWhile(item, hasPermit) {
          return hasPermit('enable_project') && item.status === 1;
        },
      },
      {
        label: '启用',
        handler(item) {
          httpRequest
            .post_modProject({ ...item, status: 1 }, '启用成功')
            .then(() => {
              $scope.queryOrgInfo();
            });
        },
        showWhile(item, hasPermit) {
          return hasPermit('enable_project') && item.status === 0;
        },
      },
      {
        label: '删除',
        handler(item) {
          sweetalert.confirm('删除确认', '确认删除该项目信息吗?').then(() => {
            httpRequest.get_delProjectById(item.projectId).then(() => {
              logger.logSuccess('删除成功');
              $scope.queryOrgInfo();
            });
          });
        },
        showWhile(item, hasPermit) {
          return hasPermit('del_project');
        },
      },
    ];

    $scope.reset = function () {
      $scope.queryParam = {
        pageNum: 1,
        pageSize: 10,
        param: {
          orgId: $scope.queryParam.param.orgId,
          projectAddress: '',
          projectCode: '',
          projectName: '',
          status: '',
        },
      };
    };

    function getStorageParam() {
      if ($scope.userType == 0) {
        if (sessionStorage.tenantProjectInfoListParam)
          return JSON.parse(sessionStorage.tenantProjectInfoListParam).param;
        return '';
      } else {
        if (sessionStorage.projectInfoListParam)
          return JSON.parse(sessionStorage.projectInfoListParam).param;
        return '';
      }
    }

    function setStorageParam(params) {
      if ($scope.userType == 0) {
        sessionStorage.setItem('tenantProjectInfoListParam', params);
      } else {
        sessionStorage.setItem('projectInfoListParam', params);
      }
    }
    // 树组件参数
    $scope.treeOptions = {
      nodeChildren: 'children',
      dirSelectable: true,
      allowDeselect: false,
      injectClasses: {
        ul: 'a1',
        li: 'a2',
        liSelected: 'a7',
        iExpanded: 'a3',
        iCollapsed: 'a4',
        iLeaf: 'a5',
        label: 'a6',
        labelSelected: 'a8',
      },
    };
  }
}
projectInfoListCtrl.$inject = [
  '$scope',
  '$uibModal',
  'httpRequest',
  '$state',
  '$stateParams',
  'dictService',
  'sweetalert',
  'initSortService',
  '$rootScope',
  'logger',
];



// WEBPACK FOOTER //
// ./src/app/system/basedata/projectInfo/projectInfoListCtrl.js